export default "<p>input-datetime-control works!</p>\n"